<template>
  <div class="container my-con z-flex">
    <myLeftCom :activeMenu="0"></myLeftCom>
    <div class="my-con-main">
      <div class="list-box">
        <el-table class="list" :data="list" stripe>
          <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column prop="mobile" label="手机号"></el-table-column>
          <el-table-column prop="balance" label="剩余试用次数"></el-table-column>
          <el-table-column prop="VipExpDate" label="会员到期时间"></el-table-column>
          <el-table-column prop="lastLoginDate" label="最后登录时间"></el-table-column>
          <el-table-column prop="regDate" label="注册时间"></el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination 
          class="pagination" 
          background 
          layout="prev, pager, next" 
          :page-size="pageSize"
          :total="total"
          hide-on-single-page
          @current-change="changePage"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState, mapActions} from "vuex";
export default {
  components: {
	  
  },
  data() {
    return {
      curPage:1,
      total:0,
      pageSize: 10,
      list:[],
    };
  },
  watch:{
    
  },
  computed: {
    ...mapState(['vuex_user'])
  },
  mounted() {
    
  },
  created() {
    this.getRows();
  },
  methods: {
    getRows(){
      this.$axios.api.request(
        {
          url: "/api.php/user/getMyInviteList",
          method: "GET",
          data: {
            user_id: this.vuex_user.id,
            page: this.curPage,
            pagesize: this.pageSize,
          },
        },
        (res) => {
          if (res.errno == 0) {
            console.log(res);
            this.total = res.data.total;
            this.list = res.data.list;
          }else{
            //判断是否登录失效
            if(res.errno == 403){
              localStorage.removeItem('token');
              this.vuexUserLogout();
              this.$parent.showLogin();
            }else{
              this.$message.error(res.message);
            }
          }
        }
      );
    },
    //分页
    changePage(e){
      this.curPage = e;
      this.getRows();
    },
  }
};
</script>

<style lang="scss" scoped>
.list-box{
  padding: 20px 30px;
  box-sizing: border-box;
  border-radius: 6px;
  background: #fff;
}
::v-deep .list{
  width: 100%;
  // background:$colorBg;
  // color: #fff;
  // tr{
  //   background:$colorBgLight;
  // }
  // .el-table__cell{
  //   border-color: #444;
  // }
}
.pagination{
  text-align:center;
  margin:30px 0 0;
}
</style>
